var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NotFound"}},[_c('v-container',[_c('div',{staticClass:"title"},[_vm._v("A página que você procura não existe :(")]),_c('v-btn',{attrs:{"to":"/editor"}},[_vm._v("Voltar")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }